import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NavBar from "../COMPONENTS/NAVBAR";
import Footer from "../COMPONENTS/FOOTER";
import styles from "./layout.module.css";

if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

// Every navigation, including a click on a link to the page already open,
// gets a new location.key. Without a #anchor the page returns to the top:
// instantly on a page change (the old page is fading out), smoothly when
// staying on the same page. #anchor links scroll to their section.
const useScrollOnNavigate = () => {
  const { pathname, hash, key } = useLocation();
  const lastPath = useRef(pathname);
  useEffect(() => {
    const samePage = lastPath.current === pathname;
    lastPath.current = pathname;
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: samePage ? "smooth" : "instant" });
      return undefined;
    }
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      tries += 1;
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(timer);
      } else if (tries > 20) {
        clearInterval(timer);
      }
    }, 100);
    return () => clearInterval(timer);
  }, [pathname, hash, key]);
};

const Layout = ({ children }) => {
  useScrollOnNavigate();
  return (
    <div className={styles.layout}>
      <a href="#main" className={styles.skip}>
        Skip to main content
      </a>
      <NavBar />
      <main id="main" className={styles.pageContent}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
